import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

export enum CartWidgetTargetObjectBase {
  CartRecommendationProduct = "cart_recommendation_product",
  CartProduct = "cart_product",
  DealTiersPage = "deal_tiers_page",
  OrderHistoryReorder = "order_history_reorder",
  PlpListView = "plp_list_view",
  ProductDetailPage = "product_detail_page",
  ProductListItem = "product_list_item",
  RepRecommendation = "rep_recommendation",
}

interface TargetObjectEntityParams {
  object_type: string;
}
export class TargetObjectEntity extends BaseEntityClass {
  object_type: string;
  constructor(params: TargetObjectEntityParams) {
    super();
    this.type = "target_object";
    this.entity_version = 17;
    this.object_type = params.object_type;
  }

  static cartWidgetObjectTypes = Object.values(CartWidgetTargetObjectBase)
    .map(location => {
      return [
        `${location}_cart_widget_add_button`,
        `${location}_cart_widget_input_field`,
        `${location}_cart_widget_remove_button`,
      ];
    })
    .flat();

  static allowedObjectTypes = [
    "account_type_card",
    "action_bar_distributor_catalog_see_all_link",
    "action_bar_go_to_list_link",
    "action_bar_see_whats_new_card",
    "action_bar_see_whats_new_link",
    "action_bar_approved_products",
    "action_bar_widget_lists_link",
    "action_bar_widget_my_distributors_link",
    "action_bar_widget_order_history_link",
    "action_bar_widget_provi_pay_link",
    "all_distributors_page_show_only_partner_distributors_checkbox",
    "all_distributors_page_sort_by_dropdown",
    "all_distributors_page_view_catalog_link",
    "first_order_bar_get_started_with_provi_button",
    "first_order_bar_see_all_distributors_button",
    "first_order_bar_add_more_distributors_button",
    "first_order_bar_add_sales_reps_button",
    "first_order_bar_add_account_number_button",
    "first_order_bar_connect_account_button",
    "add_sales_reps_button",
    "add_account_number_button",
    "connect_account_button",
    "add_to_cart",
    "carousel_left_arrow",
    "carousel_left_scroll",
    "carousel_link",
    "carousel_right_arrow",
    "carousel_right_scroll",
    "cart_add_account_number",
    "cart_add_sales_rep",
    "cart_confirm_account_details_button",
    "cart_confirm_account_details",
    "cart_confirm_save_new_account",
    "cart_confirm_account_details_edit",
    "cart_confirm_account_details_hide_modal",
    "cart_confirm_account_details_open_modal",
    "cart_download",
    "cart_order_alerts_add_a_backup",
    "cart_order_backup_notes_modal_save",
    "cart_order_fulfillment_payment_method_radio_button_cash",
    "cart_order_fulfillment_payment_method_radio_button_check",
    "cart_order_fulfillment_payment_method_radio_button_eft",
    "cart_order_fulfillment_payment_method_radio_button_debit_card",
    "cart_order_req_open",
    "cart_products_tab",
    "cart_recommendations_tab",
    "cart_save_order_for_later",
    "check_pickup_availability",
    "check_task_panel_availability",
    "close_side_menu",
    "collapse_accordion",
    "content_card",
    "connect_distributor_modal_connect_button",
    "create_account_create_button",
    "create_account_email_field",
    "create_account_first_name_field",
    "create_account_last_name_field",
    "create_account_phone_field",
    "create_account_password_field",
    "create_account_referral_button",
    "create_account_referral_field",
    "custom_content_collateral",
    "custom_content_content_block",
    "distributor_catalog_redirect",
    "distributor_shelf_talker",
    "distributor_tech_sheet",
    "distributor_catalog_add_account_number_button",
    "distributor_catalog_connect_account_button",
    "distributor_catalog_add_sales_reps_button",
    "distributor_catalog_why_link",
    "distributor_catalog_visit_storefront_link",
    "expand_accordion",
    "featured_content_mini_story_video",
    "global_nav_menu_close",
    "global_nav_menu_link",
    "global_nav_menu_open",
    "list_add_product_from_no_results_cta",
    "list_add_products",
    "list_category_filter",
    "list_container_filter",
    "list_distributor_filter",
    "list_go_to_lists_from_order_history_banner",
    "list_product_type_filter",
    "list_search_no_results_found",
    "list_sorted_distributor_name",
    "list_sorted_last_ordered_at",
    "list_sorted_position",
    "list_sorted_product_line_name",
    "list_sorted_product_type_name",
    "list_sorted_sculpture_suggested",
    "main_hamburger_menu_lists",
    "retailer_user_authentication_flow",
    "retailer_user_authentication_login_button",
    "retailer_user_authentication_create_account_button",
    "retailer_user_authentication_flow_error",
    "retailer_user_authentication_focus_field",
    "retailer_user_authentication_close_authentication_flow",
    "retailer_user_authentication_flow_continue",
    "retailer_user_authentication_flow_failed",
    "onboarding_add_business_manually_link",
    "onboarding_address_1_field",
    "onboarding_address_zip_field",
    "onboarding_autocomplete_name_field",
    "onboarding_autocomplete_distributors_field",
    "onboarding_autocomplete_sales_reps_field",
    "onboarding_back_button",
    "onboarding_city_field",
    "onboarding_continue_button",
    "onboarding_confirm_business",
    "onboarding_distributor_select",
    "onboarding_email_field",
    "onboarding_google_place_autocomplete",
    "onboarding_license_type_field",
    "onboarding_liquor_license_field",
    "onboarding_liquor_license_acknowledged",
    "onboarding_name_field",
    "onboarding_next_button",
    "onboarding_non_alcoholic_checkbox",
    "onboarding_non_alcoholic_radio_true",
    "onboarding_non_alcoholic_radio_false",
    "onboarding_phone_field",
    "onboarding_sales_rep_name_field",
    "onboarding_sales_rep_email_field",
    "onboarding_sales_rep_phone_field",
    "onboarding_save_and_finish_later_button",
    "onboarding_state_select",
    "one_way_message_opened",
    "one_way_message_x_closed",
    "open_product_group_banner",
    "open_product_group_card",
    "open_product_groups_tab",
    "open_side_menu",
    "open_support_chat",
    "order_submission_success_provi_pay_link",
    "my_distributors_see_all_distributors",
    "my_distributors_connect_a_distributor_button",
    "my_distributors_add_to_my_distributors_button",
    "pickup_or_delivery_select_delivery",
    "pickup_or_delivery_select_pickup",
    "pickup_or_delivery_modal_cancel",
    "pickup_or_delivery_modal_save",
    "pickup_or_delivery_edit_pickup_selection",
    "pickup_or_delivery_open_task_panel",
    "pickup_or_delivery_task_panel_cancel",
    "pickup_or_delivery_task_panel_save",
    "pickup_or_delivery_select_delivery",
    "pickup_or_delivery_select_pickup",
    "pdp_dual_product_select_distributor",
    "plp_no_products_discover_more_products",
    "plp_add_product",
    "product_approvals_bulk_actions_clear_all_selected",
    "product_approvals_bulk_actions_modal_trigger",
    "product_approvals_bulk_actions_select_all",
    "product_approvals_bulk_actions_select_single",
    "product_approvals_bulk_actions_send_request",
    "product_approvals_individual_send_request",
    "product_approvals_history_tab",
    "product_approvals_pending_tab",
    "product_card",
    "product_card_distributor_link",
    "product_card_image",
    "product_card_name",
    "product_card_sku_item",
    "product_card_sku_item_open_future_prices_modal",
    "product_card_sku_item_close_future_prices_modal",
    "product_index_layout_toggle_button",
    "product_list_item_name",
    "sales_rep_email",
    "sales_rep_phone_number",
    "request_item_alert_shop_distributor_button",
    "request_task_panel_add_request_button",
    "request_task_panel_close_cancel",
    "request_task_panel_close_x_button",
    "request_task_panel_open_request_button",
    "request_task_panel_open_edit_button",
    "request_task_panel_open_pencil_button",
    "request_task_panel_update_request_button",
    "search_classification_guidance_link",
    "see_other_sizes_button",
    "sell_sheet_index_date_filter_click",
    "sell_sheet_index_distributor_filter_click",
    "sell_sheet_index_search_bar_click",
    "side_menu_link",
    "shoppable_unit_hero_image",
    "shoppable_unit_logo_image",
    "shoppable_unit_link",
    "show_less_products_in_accordion",
    "show_more_products_in_accordion",
    "show_more_on_producer_description",
    "show_less_on_producer_description",
    "show_more_on_product_description",
    "show_less_on_product_description",
    "sponsored_content_page",
    "spotlight_video",
    "spotlight_button",
    "supplier_shelf_talker",
    "supplier_tech_sheet",
    "toggle_lists_to_grid_view",
    "toggle_lists_to_list_view",
  ].concat(TargetObjectEntity.cartWidgetObjectTypes);

  static fromObjectType(objectType: string): TargetObjectEntity {
    if (!this.allowedObjectTypes.includes(objectType)) {
      throw new Error(
        `${objectType} is not a valid targetObject entity type. Add it to allowedObjectTypes in target_object_entity.ts.`,
      );
    } else {
      return new TargetObjectEntity({
        object_type: objectType,
      });
    }
  }

  static areAllowedObjectTypesValid(): boolean {
    const VALID_FORMAT = /^[a-z][a-z0-9]*([_][a-z0-9]+)*$/;
    const _validate = (objectName: string) => {
      if (typeof objectName !== "string" || !objectName.match(VALID_FORMAT)) {
        throw new Error(`Invalid format for targetObject: ${objectName}`);
      }
    };

    this.allowedObjectTypes.forEach(objectName => {
      _validate(objectName);
    });

    return true;
  }
}
